import { load } from 'cheerio';
import UrlTypes from '@/enums/UrlTypes';

/**
 * ERS provider: stub for HTML-based classification.
 * TODO: implement ERS-specific source detection logic. 
 * remove | undefined
 */
export function classifyErsSource(htmlSource: string): UrlTypes | undefined {
    const $ = load(htmlSource);

    // e.g. check for ERS product container
    // if ($('.ers_product').length > 0) {
    //   return UrlTypes.PRODUCT;
    // }

    // TODO: add category / category_hub detection

    // Fallback
    return;
}
